import { Portal } from "components/portal/Portal";
import React, { FunctionComponent } from "react";
import { Trans } from "@lingui/macro";
import { array, either, option } from "fp-ts";
import { pipe, tuple } from "fp-ts/lib/function";
import { useAangifte } from "components/aangifte/AangifteProvider";
import { Action } from "domain/aangifte";
import { rubriekenFp } from "domain/rubriek";
import { useTranslate } from "./hooks/useTranslate";

export interface Props {
  filledInPartnerCodes: string[];
  action: Action;
  onClose: () => void;
}

export const ChangeBurgerlijkeStaatWarning: FunctionComponent<Props> = ({ filledInPartnerCodes, onClose, action }) => {
  const { dispatch } = useAangifte();

  const { aangifte } = useAangifte();
  const translate = useTranslate();

  const filledInPartnerRubrieken = pipe(
    filledInPartnerCodes,
    array.filterMap((code) =>
      pipe(
        aangifte.rubrieken,
        rubriekenFp.lookup(code),
        option.map((r) => tuple(code, r))
      )
    )
  );

  const clearRubriek = (code: string) => dispatch({ type: "UPDATE_RUBRIEK_VALUE", code, value: undefined });

  const handleClearPartnerCodes = () => {
    pipe(
      filledInPartnerCodes,
      array.map(clearRubriek),
      either.sequenceArray,
      either.chain(() => dispatch(action)),
      either.map(onClose)
    );
  };

  const handleCancel = onClose;

  return (
    <Portal>
      <div className="modal fade in" tabIndex={-1} role="dialog" style={{ display: "block" }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <Trans>U verandert van burgerlijke stand. De partnercodes zullen verwijderd worden.</Trans>
              </h4>
            </div>
            <div className="modal-body">
              <p>
                <Trans>
                  Codes met partnergegevens:{" "}
                  {filledInPartnerRubrieken
                    .map(([code, rubriek]) => {
                      if (rubriek.internalRubriek) return translate(rubriek.name);
                      return code;
                    })
                    .join(", ")}
                </Trans>
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal" onClick={handleCancel}>
                <Trans>Annuleren</Trans>
              </button>
              <button type="button" className="btn btn-default" onClick={handleClearPartnerCodes}>
                <Trans>OK</Trans>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

ChangeBurgerlijkeStaatWarning.displayName = "ChangeBurgerlijkeStaatWarning";
